export default __webpack_public_path__ + "static/media/Prancheta 3.878f0a0b.svg";